var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5878 9.42706L14.7409 10.9914C15.0914 11.246 15.2381 11.6974 15.1042 12.1094L14.2818 14.6406C14.1479 15.0526 13.7639 15.3316 13.3307 15.3316H10.6693C10.2361 15.3316 9.85211 15.0526 9.71824 14.6406L8.89582 12.1094C8.76194 11.6974 8.9086 11.246 9.25909 10.9914L11.4122 9.42706C11.7627 9.17242 12.2373 9.17242 12.5878 9.42706Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20.5C11.2404 20.5 10.5041 20.4004 9.80336 20.2134L9.18937 17.7575C9.07807 17.3123 8.67809 17 8.21922 17H5.1254C4.24292 15.7887 3.67278 14.3354 3.53336 12.7582L6.29675 10.9581C6.70345 10.6932 6.86118 10.1744 6.67079 9.72796L5.37082 6.67937C6.32206 5.4957 7.58379 4.57218 9.0324 4.0324L11.2929 6.29289C11.6834 6.68342 12.3166 6.68342 12.7071 6.29289L14.9676 4.0324C16.4162 4.57218 17.6779 5.4957 18.6292 6.67937L17.3292 9.72796C17.1388 10.1744 17.2965 10.6932 17.7032 10.9581L20.4666 12.7582C20.3272 14.3354 19.7571 15.7887 18.8746 17H15.7808C15.3219 17 14.9219 17.3123 14.8106 17.7575L14.1966 20.2134C13.4959 20.4004 12.7596 20.5 12 20.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball);
export default __webpack_public_path__ + "static/media/football.3b22ab7e61d91e449c09a4d6e8cee544.svg";
export { ForwardRef as ReactComponent };